export default __webpack_public_path__ + "static/media/donacion_tratamiento.034721cc.png";